import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';
import { RecommendationsFormComponent } from '../recommandations-form/recommandations-form.component';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { SelectRegionComponent } from 'src/app/select-region/select-region.component';
import { PopUpService } from 'src/app/popupservice.service';
import { NearbyMapComponent } from 'src/app/nearby-map/nearby-map.component';
import { SearchService } from 'src/app/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-community-trending',
  templateUrl: './community-trending.component.html',
  styleUrls: [
    './../filter-products/filter-products.component.scss',
    './community-trending.component.scss',
  ],
})
export class CommunityTrendingComponent implements AfterViewInit, OnDestroy {
  constructor(
    private customerService: CustomerService,
    private commonService: CommonService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private bottomSheet: MatBottomSheet,
    private local: LocalServiceService,
    private popup: PopUpService,
    private searchService: SearchService,
    private router: Router
  ) {}
  ngOnDestroy(): void {
    this._regionListenerSubscription?.unsubscribe();

    this.destroy$.complete();
  }

  private destroy$ = new Subject();

  @Output()
  public loginWhy = new EventEmitter();

  @Output()
  public onViewProducts = new EventEmitter();

  public viewProductDetails(prod) {
    this.onViewProducts.emit(prod);
  }

  public areThereMore = false;

  public onProductsSwiper(swiper) {
    this.areThereMore = !swiper.isEnd;
    // this.cdr.detectChanges();
  }
  public onProductSlideChange(swiper) {
    this.areThereMore = !swiper.isEnd;
    this.cdr.detectChanges();
  }

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    pagination: false,
    slidesPerGroup: 2,
    freeMode: true,
  };

  //Technology / Cleaner / Pets / Education
  bottomCategories = [
    { name: 'Local Delights' },
    { name: 'Education' },
    { name: 'Beauty', need: 'Beauty & Grooming' },
    { name: 'TCM' },
    { name: 'Cleaning' },
    { name: 'Pets' },
    { name: 'Plumbing' },
  ];

  public allBottomProducts: {
    currentPage: number;
    data: Array<any>;
    lastPage: number;
    totalCount: number;
  } = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0,
  };

  filteredBottomProducts: any = [];
  public bottomProductsSubCategory = '';
  public bottomProductsSubCategoryId = null;
  public imgUrl = environment.ImageUrl;

  public region: {
    id: number;
    name: string;
  };
  public allRegions = [];
  private _regionListenerSubscription?: Subscription = null;

  private _activeModal = null;
  public openSelectRegionModal() {
    this._activeModal = this.modalService.open(SelectRegionComponent);
    this._activeModal.componentInstance.selectOnlyOne = true;
    this._activeModal.closed.pipe(takeUntil(this.destroy$)).subscribe((r) => {
      if (!r) {
        console.error('invalid region returned from modal!');
        return;
      }
      this.region = r;
      r.id = r.subRegionId;
      // console.log("changing region to", r)
      this.refreshBottomProducts();
    });
  }
  ngAfterViewInit() {
    this._regionListenerSubscription =
      this.commonService.subRegionListBaseProductObserver.subscribe(
        (region) => {
          this.allRegions = region;
          const filteredRegion = region.filter(
            (item) => item.productCountEducation > 0
          );
          const length = filteredRegion.length;
          if (length > 0) {
            const randomIndex = Math.floor(Math.random() * length);
            this.region = {
              id: filteredRegion[randomIndex].subRegionId,
              name: filteredRegion[randomIndex].name,
            };
            this.initProducts();
          }
        }
      );
  }

  initProducts() {
    this.customerService
      .getAllCommunityProductCategoryList()
      .subscribe((response: any) => {
        response = response.body;
        this.bottomCategories.forEach((row) => {
          const find = response.find(
            (value) =>
              row.need?.toLowerCase()?.trim() ==
                value.name?.toLocaleLowerCase()?.trim() ||
              row.name?.toLowerCase()?.trim() ==
                value.name?.toLocaleLowerCase()?.trim()
          );
          if (find) {
            (row as any).id = find.id;
          }
        });
        this.loadProducts(this.bottomCategories[0], true);
      });
  }

  memberShopProductList: any = [];

  public isLoading: boolean = true;
  public showtCarousel = true;
  public refreshBottomProducts(page: number = 1, resetCarousel = false) {
    try {
      if (resetCarousel) {
        this.showtCarousel = false;
        this.cdr.detectChanges();
      }
      if (this.bottomProductsSubCategoryId == null) {
        this.allBottomProducts = {
          currentPage: 1,
          data: [],
          lastPage: 1,
          totalCount: 0,
        };
        this.isLoading = false;
        this.isLoading = false;
        this.showtCarousel = true;
        return;
      }

      this.isLoading = true;
      this.cdr.detectChanges();

      this.customerService
        .getMemberShopProductList({
          categoryId: this.bottomProductsSubCategoryId,
          isAdmin: false,
          page: page,
          basedProduct: 'all',
          subRegionId: [this.region.id],
        })
        .subscribe({
          next: (data: any) => {
            data = data.body;
            if (data.currentPage === 1) this.allBottomProducts.data = [];
            if (data?.data)
              this.allBottomProducts = {
                ...data,
                data: [...this.allBottomProducts.data, ...data?.data],
              };
            this.isLoading = false;
            this.showtCarousel = !!this.allBottomProducts?.data?.length;
            this.cdr.detectChanges();
          },
          error: (err) => {
            this.isLoading = false;
            console.error(err);
            this.isLoading = false;
            this.showtCarousel = false;
            this.cdr.detectChanges();
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  loadProducts(category: any, isInit = false) {
    if (this.bottomProductsSubCategory == category.name && !isInit)
      return false;
    this.bottomProductsSubCategory = category.name;
    this.bottomProductsSubCategoryId = category.id;
    this.refreshBottomProducts(1, true);
  }

  private modalRef?: null | NgbModalRef | MatBottomSheetRef = null;

  public closeActiveModal() {
    this.modalRef.dismiss();
  }

  public openRecommendationForm() {
    if (!this.local.getUser()) {
      this.loginWhy.next({ name: 'add a recommendation', fixZIndex: true });
      return;
    }
    // if (this.sharedService.isOnMobile) {
    //   this.modalRef = this.bottomSheet.open(RecommendationsFormComponent, {
    //     panelClass: 'bottom-sheet-1',
    //     hasBackdrop: true,
    //   })
    //   this.modalRef.instance.activeModal = this.modalRef;
    // } else {
    //   this.modalRef = this.modalService.open(RecommendationsFormComponent);
    // }
    this.modalRef = this.popup.openPopup(RecommendationsFormComponent, {
      hasBackdrop: true,
      bottomSheetPanelClass: 'bottom-sheet-1',
    });
  }

  public timeout1: any;
  openFilterModal(isCategoryOnlySearch = false) {
    // this.local.clearTimeout(this.timeout1);
    // this.modalService.dismissAll();
    // const ref = this.popup.openPopup(NearbyMapComponent, {
    //   forceMode: 'modal',
    //   modalSize: 'lg',
    //   // focusFirst: false
    // }) as NgbModalRef;
    // ref.componentInstance.search('', isCategoryOnlySearch);
    // this.searchService.addInSavedSearch('');

    // // Disable Auto-Focus Using Modal Options
    // this.timeout1 = setTimeout(() => {
    //   const modalElement = document.querySelector('.modal');
    //   const firstInput = modalElement?.querySelector(
    //     'input, button, select, textarea, a[href]'
    //   );
    //   if (firstInput) {
    //     (firstInput as HTMLElement).blur();
    //   }
    // }, 0);
    this.router.navigateByUrl('/map');
  }
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767;
  }
}
